export const DEFAULT_COOKIE_PATH = '/'

export const CABINET_OPENED_EVENT_NAME = 3
